import { render, staticRenderFns } from "./FullServiceProperties.vue?vue&type=template&id=66aa49b0&scoped=true&"
import script from "./FullServiceProperties.vue?vue&type=script&lang=js&"
export * from "./FullServiceProperties.vue?vue&type=script&lang=js&"
import style0 from "./FullServiceProperties.vue?vue&type=style&index=0&id=66aa49b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa49b0",
  null
  
)

export default component.exports